// extracted by mini-css-extract-plugin
export default {"icon":"Icon__icon___x2lKG"};